import { assertEx } from '@xylabs/sdk-js'
import { GeoJson, MercatorBoundingBox } from '@xyo-network/sdk-xyo-js'
import { Quadkey } from '@xyo-network/sdk-xyoworld-js'
import { Feature } from 'geojson'
// eslint-disable-next-line no-restricted-imports
import { GeoJSONSource, Map } from 'mapbox-gl'

class Source {
  public id: string

  private updating = false

  constructor(id: string) {
    this.id = id
  }

  getSource(boundingBox: MercatorBoundingBox, zoom: number) {
    const quadkeys = Quadkey.fromBoundingBox(boundingBox, zoom + 1).sort()
    console.log(`QuadkeyGetSource: ${quadkeys.length}`)
    const features: Feature[] = []
    for (const quadkey of quadkeys) {
      features.push({
        ...quadkey.geoJson().polygonFeature(),
        properties: {
          assayBalance: 0,
          coinDensity: 0,
          quadkey: quadkey.toBase4HashLabel(),
          storageBalance: 0,
          tileVector: JSON.stringify(quadkey.toTile()),
        },
      })
    }
    const featuresCollection = GeoJson.featureCollection(features)
    console.log(`Setting Quadkey Source: ${features.length}`)
    return GeoJson.featuresSource(featuresCollection)
  }

  update(map: Map, show = true) {
    if (this.updating) {
      return
    }
    this.updating = true
    try {
      const bounds = map.getBounds()
      const existingSource = map.getSource(this.id) as GeoJSONSource
      if (show) {
        const source = this.getSource(bounds, map.getZoom())
        if (existingSource) {
          existingSource.setData(assertEx(source.data as Feature))
        } else {
          map.addSource(this.id, source)
        }
      } else {
        if (existingSource) {
          map.removeSource(this.id)
        }
      }
    } finally {
      this.updating = false
    }
  }
}

export default Source
